import { useState } from 'react';
import { Content } from 'components';
import { Button, List, Tag, Modal } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { TagApi } from 'api';
import { useQueryClient } from '@tanstack/react-query';
import MessageAlert from 'utils';
import moment from 'moment';
import styled from 'styled-components';
import TagModifyPopup from './TagModifyPopup';

const TagList = ({ tagList, selectedTag, onChangeSelectedTag }) => {
  const [modifyPopupInfo, setModifyPopupInfo] = useState({ isOpen: false, defaultData: null });
  const queryClient = useQueryClient();

  const handleClickTag = (tag) => {
    if (tag) {
      onChangeSelectedTag(tag);
    }
  }

  const handleUpdateTag = (tag) => {
    setModifyPopupInfo({
      isOpen: true,
      defaultData: tag
    })
  }

  const handleDeleteTag = (tag) => {
    Modal.confirm({
      title: '정말 이 태그를 삭제하시겠습니까?',
      content: `삭제 태그 : ${tag.tag_name}`,
      okText: '삭제',
      onOk: async () => {
        if (tag.tag_id) {
          const response = await TagApi.deleteTag(tag.tag_id);

          if (response && response.status === 200) {
            MessageAlert.success('태그를 삭제하였습니다.')
            queryClient.resetQueries({ queryKey: ['tag'] }); 
          } else {
            MessageAlert.error('태그 삭제 중 오류가 발생하였습니다.');
          }
        }
      },
      cancelText: '취소',
      onCancel() {},
    })
  }

  return (
    <Content
      maxWidth='100%'
      borderRadius={4}
      padding={20}
      style={{ height: '100%' }}
    >
      <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
        검색 결과 총 <span>{tagList.length}</span>건
      </h4>
      <List
        itemLayout="horizontal"
        dataSource={tagList}
        renderItem={(item) => (
          <ListItem 
            key={item.tag_id} 
            isActive={(selectedTag && selectedTag.tag_id === item.tag_id) ? true : false}
            onClick={() => handleClickTag(item)}
          >
            <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
              <div>
                <div>
                  {item.tag_name}
                </div>
                <div style={{ fontSize: '12px', color: 'gray' }}>                            
                  {item.is_show === 'Y' ? (
                    <Tag color="success">노출</Tag>
                  ) : (
                    <Tag color="default">미노출</Tag>
                  )}
                  &nbsp;
                  {moment.unix(item.updated_at).format('YYYY-MM-DD')}
                </div>
              </div>
              <div>
                <Button 
                  size='small' 
                  icon={<EditOutlined />}
                  onClick={() => handleUpdateTag(item)}
                />
                &nbsp;
                &nbsp;
                <Button 
                  size='small' 
                  icon={<DeleteOutlined />} 
                  danger 
                  onClick={() => handleDeleteTag(item)}
                />
              </div>
            </div>
          </ListItem>
        )}
      />
      <TagModifyPopup 
        isOpen={modifyPopupInfo.isOpen}
        defaultData={modifyPopupInfo.defaultData}
        tagList={tagList}
        onClose={() => setModifyPopupInfo({ isOpen: false, defaultData: null })}
      />
    </Content>
  )
}

const ListItem = styled(List.Item)`
  cursor: pointer; 
  border: 1px solid #d8d8d8 !important;
  border-radius: 10px; 
  padding: 20px 10px !important;
  margin-bottom: 5px;

  &:hover {
    background-color: #e5f2ff;
  }

  background-color: ${({ isActive }) => isActive ? '#e5f2ff' : 'none'};
`

export default TagList;